import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './Breadcrumbs.scss';

const Breadcrumb = ({ url, name, className }) => {
  const breadcrumbClassName = classNames('breadcrumbs__item', className);

  return (
    <li className={breadcrumbClassName}>
      <span className="breadcrumbs__arrow-right" />
      <a className="breadcrumbs__link u-fontSize-xxs" href={url}>
        {name}
      </a>
      <span className="breadcrumbs__separator" />
    </li>
  );
};

Breadcrumb.propTypes = {
  url: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default Breadcrumb;
